<template>
    <div class="components-time-box">
        <div class="box-title">
            <img :src="props.data.icon" alt="" />
            <div class="text">{{props.data.title }}</div> 
        </div>
        <!-- <div class="box-buzhou">
            <div class="line"></div>
            <img src="https://p5.ssl.qhimg.com/t110b9a93019dee4f6463c16cd4.png" alt="" />
        </div> -->
        <div class="box-list">
            <div class="list-item" v-for="item in props.data.list" :key="item.title">
                <img class="item-icon" :src="item.icon" alt="" />
                <div class="item-title">{{item.title}}</div>
                <div class="item-content">
                    {{item.desc}}
                </div>
                <div class="line"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const jumpPath = () => {
  window.open(props.data.toUrl)
}
</script>

<style lang="scss" scoped>
.components-time-box{
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 48px;
    .box-title{
        display: flex;
        align-items: center;
        img{
            width: 22px;
            height: 22px;
        }
        .text{
            color: rgb(38, 38, 38);
            font-family: 阿里巴巴普惠体 2.0;
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 0px;
            margin-left: 12px;
        }
    }
    // .box-buzhou{
    //     width: 100%;
    //     position: absolute;
    //     top: 96px;
    //     z-index: 10;
    //     .line{
    //         width: 1px;
    //         height: 100px;
    //         background: rgb(30, 89, 191);
    //     }
    //     img{
    //         width: 12px;
    //         height: 12px;
    //         position: absolute;
    //         left: calc(100% - 12px);
    //         transform: translateY(-50%);
    //     }
    // }
    .box-list{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 36px;
        padding: 0 46px 0 10px;
        .list-item{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 16px;
            .item-icon{
                width: 30px;
                height: 38px;
            }
            .item-title{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 16px;
                font-weight: 700;
                line-height: 14px;
                letter-spacing: 0px;
                margin-top: 12px;
            }
            .item-content{
                color: rgb(38, 38, 38);
                font-family: 阿里巴巴普惠体 2.0;
                font-size: 12px;
                font-weight: 300;
                line-height: 16px;
                letter-spacing: 0px;
                margin-top: 8px;
            }
            .line{
                width: 1px;
                height: 50px;
                border-left: 1px dashed rgb(30, 89, 191);
                margin-top: 16px;
            }
            &:last-child{
                margin-bottom: 0px;
                .line{
                    display: none;
                }
            }
        }
    }
}
</style>
